module.exports = __webpack_public_path__ + "img/full0-min.ef6fd788.png";